import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/price-elasticity-calculator',
  component: () => import('../../routes/PriceElasticityCalculator.svelte'),
  card: {
    id: 'price-elasticity-calculator',
    title: 'Price Elasticity of Demand',
    description: 'Calculate how sensitive demand is to price changes using the midpoint elasticity formula. Understand elastic, inelastic, and unitary demand.',
    icon: 'trending_flat',
    iconBgClass: 'bg-amber-50',
    iconTextClass: 'text-amber-600',
    href: '/price-elasticity-calculator',
    category: 'Business',
  },
  seo: {
    title: 'Price Elasticity of Demand Calculator – Free PED Calculator',
    description: 'Free price elasticity of demand calculator using the midpoint method. Calculate PED to understand how quantity demanded responds to price changes for your products or services.',
  },
};

export default meta;
